import dayjs from 'dayjs';

/** "1. Mai 2026" — first renewal date for a subscription (start + 1 period). */
export const formatFirstRenewalDate = (startDate: string): string =>
	dayjs(startDate).add(1, 'month').format('D. MMMM YYYY');
